/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_CopiedInputs */

const vi_api_keys_copied = /** @type {(inputs: Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sao chép khóa`)
};

/**

* @param {Api_Keys_CopiedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_copied = /** @type {((inputs?: Api_Keys_CopiedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_CopiedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_copied(inputs)
});